module.exports = __webpack_public_path__ + "img/purchased-coins.2bc4294f.svg";